import { bankApi, fetchcardApi } from '@/api'

const BASE = '/cms'
const BASE_CMS = '/api'

export interface ICMSNoticeRequest {
  count: number // 조회 대상 갯수
  languageCode: string // 조회 대상 언어코드
  lastItemId: string // 마지막 항목 ID
}

export interface INoticeResponse {
  contents: string // 내용
  createdAt: number // 생성 timestamp
  itemId: string // item id
  title: string // 제목
}

export interface ICMSNoticeResponse {
  lastItemId: string //마지막 항목 id
  list: INoticeResponse[] // 공지사항 리스트
}

export function fetchNoticeList(data: ICMSNoticeRequest): Promise<ICMSNoticeResponse> {
  return bankApi.post(`${BASE}/notice/list`, data)
}

export interface ICMSRequest {
  languageCode: string
}

export interface IHelpResponse {
  title: string // 제목
  html: string // help html contents
  text: string // help text contents
}

export interface IHelpSubCategoryResponse {
  subCategoryName: string // 상위 카테고리 명
  list: IHelpResponse[] // help 리스트
}

export interface IHelpCategoryResponse {
  categoryName: string // 상위 카테고리 명
  list: IHelpSubCategoryResponse[] // 카테고리 리스트
}

export interface ICMSHelpResponse {
  helps: IHelpCategoryResponse[] // 도움말 FAQ
}

export function fetchHelpList(data: ICMSRequest): Promise<ICMSHelpResponse> {
  return bankApi.post(`${BASE}/help/list`, data)
}

/** 20230331 - BT-21 */
export interface ICMSCommonRequest {
  languageCode: string //language code for POST to cms
  grpCodeid: string //group code id for POST to cms
}

/** 20230331 - BT-21 */
export interface ICMSCommonResponse {
  name: string
  inqCard: string
  imgCard: string
  cardType: string
  cardVersion: string
  dummy: string
  cardName: string
  cardDesc: string
  unavailableMsg: string
  sequence: string
  cardBrand: string
}

/** 20230331 - BT-21 */
export function fetchCommonList(data: ICMSCommonRequest): Promise<ICMSCommonResponse> {
  return fetchcardApi.post(`${BASE_CMS}/id/common/v1/list/key-value`, data)
}
